import React from 'react'
import { MessageBus, MessageBusTypes } from 'common-tools/MessageBusHelper'
import { Button, CatchError } from 'common-controls/Core'
import styles from './DrawerContainer.less'
import _ from 'common-tools/LodashHelper'
import { log, componentGetCompareProps } from 'common-tools/index'
import { compose, ReduxWrapper, ah, sh } from 'common-data/datahelpers'
import { motion, AnimatePresence } from 'framer-motion'

const DrawerBoxVariants = {
  animate: {
    x: 0,
    transition: {
      duration: 0.150,
      ease: 'easeOut'
    }
  },
  exit: {
    x: '100%',
    transition: {
      duration: 0.100,
      ease: 'easeIn'
    }
  },
  initial: {
    x: '175%'
  }
}

const PopupBoxVariants = {
  animate: {
    y: 0,
    transition: {
      duration: 0.150,
      ease: 'easeOut'
    }
  },
  exit: {
    y: '-250%',
    transition: {
      duration: 0.100,
      ease: 'easeIn'
    }
  },
  initial: {
    y: '-250%'
  }
}

const OverlayBoxVariants = {
  animate: {
    opacity: 0.5,
    transition: {
      duration: 0.120
    }
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.100
    }
  },
  initial: {
    opacity: 0
  }
}

const BackdropVariants = {
  show: {
    position: 'absolute',
    transition: {
      when: 'beforeChildren'
    }
  },
  hide: {
    position: 'relative'
  }
}

class DrawerContainerPlain extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      openDrawers: false
    }
  }

  componentDidUpdate (prevProps, prevState) {
    const { openDrawers } = this.state

    const openDrawersDiff = componentGetCompareProps('DrawerList.length', this.props, prevProps, 0)

    if (openDrawersDiff.Current > 0 & openDrawers === false) {
      this.setState({
        openDrawers: true
      })
    }
  }

  getEmptyDrawer () {
    return (props) => {
      return <div style={{ drawerStyle: props.drawerStyle }}>
        <p>Empty Drawer!</p>
        <Button type='Danger' onClick={this.props.close}>Close</Button>
      </div>
    }
  }

  renderDrawers () {
    const { DrawerList, closeDrawer, showError } = this.props

    let drawerList = []
    // let lastSize = ''

    _.each(DrawerList, (d, i) => {
      let drawerSize = d.drawerSize || 'Half'
      let drawerProps = d.props || {}
      let DrawContents = d.component || this.getEmptyDrawer()
      let messageBusKey = d.messageBusKey

      let zIndexStyle = {
        zIndex: 1000 + i
      }

      drawerList.push(
        <motion.div {...OverlayBoxVariants} key={`drawer-overlay-${i}`} style={zIndexStyle} className={styles.overlay} />
      )

      const BoxVariants = _.startsWith(drawerSize, 'Popup') ? PopupBoxVariants : DrawerBoxVariants

      drawerList.push(
        <motion.div {...BoxVariants} key={`drawer-${i}`} style={zIndexStyle} className={styles[`drawer${drawerSize}`]}>
          <CatchError close={() => { closeDrawer(d.key) }}>
            <DrawContents close={(actions) => {
              try {
                MessageBus.send(MessageBusTypes.DrawEvents, { actions: actions, messageBusKey: messageBusKey })
              } catch (err) {
                log.Error('Drawer Post Action CallBack Error', { Error: err })
                showError('Unable to complete post action callbacks, see console for details!')
              }
              closeDrawer(d.key)
            }} fire={(actions) => {
              try {
                MessageBus.send(MessageBusTypes.DrawEvents, { actions: actions, messageBusKey: messageBusKey })
              } catch (err) {
                log.Error('Drawer Fire Event CallBack Error', { Error: err })
                showError('Unable to complete fire event callbacks, see console for details!')
              }
            }} {...drawerProps} />
          </CatchError>
        </motion.div>
      )

      // lastSize = drawerSize
    })

    return drawerList
  }

  render () {
    const { openDrawers } = this.state

    return (
      <div style={{ position: openDrawers === true ? 'fixed' : 'relative' }} key='drawerBackdrop' className={styles.drawerBackdrop}>
        <CatchError>
          <AnimatePresence onExitComplete={() => { this.setState({ openDrawers: false }) }}>
            {this.renderDrawers()}
          </AnimatePresence>
        </CatchError>
      </div>
    )
  }
}

export const DrawerContainer = compose(
  ReduxWrapper([
    sh.DrawerList
  ], [
    ah.closeDrawer,
    ah.showError
  ])
)(DrawerContainerPlain)

export default DrawerContainer
